import React, { useEffect } from "react";
import "../assets/css/LeaveCartPopup.css";

const LeaveCartPopup = ({
  open,
  onClose,
  onConfirm,
  storeInfo = {},
  storeInfoConfig = {},
}) => {
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  const primaryColor =
    storeInfoConfig?.general_config?.primary_color ||
    storeInfo?.primary_color ||
    "#E8450A";

  const hoverBg = primaryColor.startsWith("#")
    ? `${primaryColor}0A`
    : "rgba(232, 69, 10, 0.04)";

  return (
    <div
      className="leave-cart-popup-overlay"
      onClick={onClose}
    >
      <div
        className="leave-cart-popup-card"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Full-Width Header Row with Edge-to-Edge Divider */}
        <div className="leave-cart-popup-header">
          <h3
            className="leave-cart-popup-title"
            style={{ color: primaryColor }}
          >
            Leave Cart?
          </h3>
          <button
            className="leave-cart-popup-close-btn"
            onClick={onClose}
            style={{ color: primaryColor }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = hoverBg)}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Body Content matching OrderTypePopup */}
        <div className="leave-cart-popup-body">
          {/* Main Icon Badge */}
          <div
            className="leave-cart-popup-icon-badge"
            style={{ backgroundColor: `${primaryColor}15` }}
          >
            <svg
              width="38"
              height="38"
              viewBox="0 0 24 24"
              fill="none"
              stroke={primaryColor}
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
          </div>

          {/* Subtitle / Warning Description matching OrderTypePopup typography */}
          <div className="leave-cart-popup-subtitle">
            Leaving the cart will clear all items currently in your cart. Are you sure you want to leave?
          </div>

          {/* Action Buttons matching OrderTypePopup exactly */}
          <div className="leave-cart-popup-actions">
            <button
              className="leave-cart-popup-btn leave-cart-popup-btn-contained"
              onClick={onClose}
              style={{
                backgroundColor: primaryColor,
                color: "#ffffff",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
            >
              No, Stay
            </button>
            <button
              className="leave-cart-popup-btn leave-cart-popup-btn-outlined"
              onClick={onConfirm}
              style={{
                border: `2px solid ${primaryColor}`,
                color: primaryColor,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = hoverBg)}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
            >
              Yes, Leave
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveCartPopup;
